<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="pageInfo bumiKini">
      <div class="pageInfoWrapper">
        <h2>Kelas Iklim</h2>
        <h4>Mengulas kembali sesi kelas iklim yang membahas komitmen Indonesia bagi bumi.</h4>
        <p v-if="1>2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat.</p>
      </div>
    </div>
    <div class="kelasIklimCnt">
      <div class="kelasIklimWrapper">
        <div class="kelas-iklim-item" v-for="item in podcast" :key="item.id">
          <div class="itemImg" v-on:click="$emit('play', item)">
            <div class="theImg" v-bind:style="{backgroundImage: `url(${item.thumb})`}"></div>
            <div class="view"></div>
            <div class="imgOverlay">
              <div class="playBtn">
                <div class="playIcon"></div>
                Dengarkan
                <span>{{item.duration}}</span>
              </div>
            </div>
          </div>
          <h4 v-on:click="$emit('play', item)">{{item.title}}</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: true,
      podcast: [],
      timer: null,
      currentIndex: 0,
      pageActive: 0,
    };
  },
  computed: {
    currentImg() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    startSlide() {
      this.timer = setInterval(this.next, 6000);
    },
    next() {
      this.currentIndex = (this.currentIndex >= this.images.length - 1) ? 0 : this.currentIndex + 1;
    },
    prev() {
      this.currentIndex -= 1;
    },
    goToSlide(idx) {
      clearInterval(this.timer);
      this.currentIndex = idx;
      this.startSlide();
    },
    mouseOver(idx) {
      this.pageActive = idx;
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Kelas Iklim NDC Series - Bumi Butuh Aksi';
    this.$http.get(this.$config.uri('podcast/all/kelas-iklim')).then((response) => {
      this.podcast = (response.data.status === 200) ? response.data.data : [];
      this.loading = false;
    });
  },
};
</script>

<style scoped lang="scss">
  .pageInfo{
    background-image: url(../assets/kelas-iklim.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    margin-top: 71px;
    @media (max-width: 760px) {
      margin-top: 62px;
    }
    &:before{
      content: ""; display: block;
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: linear-gradient(rgba(255, 255, 255, .5), #fff);
    }
    .pageInfoWrapper{
      position: relative;
      z-index: 2;
      max-width: 1240px;
      margin: 0 auto -120px;
      padding: 40px 0 160px;
      h2{
        margin: 0;
        font-size: 60px;
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        max-width: 700px;
      }
      p{
        margin: 0;
        max-width: 700px;
      }
      @media (max-width: 760px) {
        padding-top: 30px;
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
    }
  }

  .sectionTitle{
    margin: 20px 0;
    font-weight: bold;
    font-size: 30px;
  }
  .kelasIklimCnt{
    max-width: 1240px;
    margin: 0 auto;
    min-height: calc(100vh - 300px);
    position: relative;
    z-index: 2;
    .kelasIklimWrapper{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
    }
    .kelas-iklim-item{
      width: calc(25% - 20px);
      margin: 0 10px;
      padding-bottom: 30px;
      .itemImg{
        height: 295px;
        background-color: #ccc;
        margin-bottom: 10px;
        position: relative;
        cursor: pointer;
        transition: all .2s ease;
        .theImg{
          background-position: center;
          background-size: cover;
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          z-index: 2;
          transition: all .2s ease;
        }
        .imgOverlay{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-color: rgba(0,0,0,.6);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all .2s ease;
          z-index: 3;
          .playBtn{
            position: relative;
            font-size: 15px;
            padding: 4px 20px 6px;
            padding-left: 46px;
            border-radius: 100px;
            font-weight: bold;
            background-color: transparent;
            transition: all .2s ease;
            &:hover{
              background-color: #31c1f4;
            }
            .playIcon{
              width: 30px;
              height: 30px;
              position: absolute;
              left: 10px; top: 8px;
              background-image: url(../assets/play_circle_outline-white-18dp.svg);
              background-position: center;
              background-size: contain;
              background-repeat: no-repeat;
            }
            span{
              display: block;
              font-size: 12px;
              font-weight: normal;
            }
          }
        }
        .view{
          position: absolute;
          left: 4px; top: 4px; right: -6px; bottom: -6px;
          background-color: #31c1f4;
          color: #fff;
          display: flex;
          align-items: center;
          transition: all .2s ease;
          justify-content: center;
          opacity: 0;
          z-index: 1;
        }
        &:hover{
          .imgOverlay, .view{
            opacity: 1;
          }
          transform: scale(1.02);
        }
      }
      h4{
        margin: 0 4px 10px;
        cursor: pointer;
        &:hover{
          color: #31c1f4;
        }
      }
      .author{
        position: relative;
        padding-left: 50px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #767676;
        display: none;
        .authorImg{
          width: 40px;
          height: 40px;
          background-color: #999;
          border-radius: 50%;
          position: absolute;
          left: 0; top: 0;
        }
        h4{
          font-size: 16px;
          margin: 0;
          color: #444;
        }
      }
    }
  }

</style>
